import { render, staticRenderFns } from "./AreaInvestigacionPage.vue?vue&type=template&id=b053b79c"
import script from "./AreaInvestigacionPage.js?vue&type=script&lang=js&external"
export * from "./AreaInvestigacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports